import React from "react"
import {FieldManagementPreviewProps} from "../../../render/management-preview";
import FieldView from "../../../render/view";


export default function FieldDropdown_ManagementPreview(props:FieldManagementPreviewProps) {

    let option;

    if (props.field.options && props.field.options[0]) option = props.field.options[0];
    else {
        option = {
            label: 'Option 1',
            value: 'test-id'
        }
    }

    const model:any = {}
    model[props.field.fieldId] = option.value

    return (
        <FieldView field={props.field} model={model} />
    )

}